/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ActionTypeEnum = "AutopilotTurnedOff" | "AutopilotTurnedOn" | "ClockwiseCouldNotResolveConflict" | "ClockwiseMeetingMove" | "ClockwiseMovePaused" | "ClockwiseMoveUnpaused" | "EventCreated" | "EventRescheduled" | "NextAutopilotRun" | "%future added value";
export type AutopilotEventStatusEnum = "CanMove" | "EventExceedsDefragRange" | "EventOutsideTimeRange" | "External" | "NoDuration" | "OverQuota" | "Paused" | "Pinned" | "PrivateEvent" | "SmartHold" | "%future added value";
export type StatusEnum = "AutopilotHistoryIncomplete" | "AutopilotHistoryNotVisible" | "AutopilotHistoryOff" | "AutopilotHistoryOn" | "%future added value";
export type AutopilotEventHistory_event = {
    readonly eventAutopilotHistory: ({
        readonly __typename: "EventAutopilotHistory";
        readonly status: StatusEnum;
        readonly actions: ReadonlyArray<{
            readonly actionType: ActionTypeEnum;
            readonly actionString: string;
            readonly actionInfo: ReadonlyArray<string>;
            readonly timestamp: unknown;
        }>;
    } | {
        readonly __typename: "GraphEntityError";
        readonly message: string | null;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    }) | null;
    readonly eventKey: {
        readonly externalEventId: string;
    };
    readonly title: string | null;
    readonly autopilotEventStatus: ({
        readonly __typename: "AutopilotEventStatus";
        readonly status: AutopilotEventStatusEnum | null;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    }) | null;
    readonly startTime: {
        readonly dateOrDateTime: string;
    };
    readonly featureStatesForOrganizer: ({
        readonly __typename: "FeatureStates";
        readonly mixedFreemiumOrgUIState: {
            readonly autopilotPaused: boolean;
        };
    } | {
        readonly __typename: "GraphEntityError";
        readonly statusCode: number | null;
        readonly message: string | null;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    }) | null;
    readonly " $refType": "AutopilotEventHistory_event";
};
export type AutopilotEventHistory_event$data = AutopilotEventHistory_event;
export type AutopilotEventHistory_event$key = {
    readonly " $data"?: AutopilotEventHistory_event$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"AutopilotEventHistory_event">;
};



const node: ReaderFragment = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
    } as any, v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
    } as any;
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "calendarId"
            }
        ],
        "kind": "Fragment",
        "metadata": null,
        "name": "AutopilotEventHistory_event",
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "eventAutopilotHistory",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v1 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "AutopilotHistoryActionLog",
                                "kind": "LinkedField",
                                "name": "actions",
                                "plural": true,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "actionType",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "actionString",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "actionInfo",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "timestamp",
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "type": "EventAutopilotHistory",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v2 /*: any*/)
                        ],
                        "type": "GraphEntityError",
                        "abstractKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "EventKey",
                "kind": "LinkedField",
                "name": "eventKey",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "externalEventId",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
            },
            {
                "alias": null,
                "args": [
                    {
                        "kind": "Variable",
                        "name": "calendarId",
                        "variableName": "calendarId"
                    }
                ],
                "concreteType": null,
                "kind": "LinkedField",
                "name": "autopilotEventStatus",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            (v1 /*: any*/)
                        ],
                        "type": "AutopilotEventStatus",
                        "abstractKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "EventTime",
                "kind": "LinkedField",
                "name": "startTime",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "dateOrDateTime",
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "featureStatesForOrganizer",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "MixedFreemiumOrgUiState",
                                "kind": "LinkedField",
                                "name": "mixedFreemiumOrgUIState",
                                "plural": false,
                                "selections": [
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "autopilotPaused",
                                        "storageKey": null
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "type": "FeatureStates",
                        "abstractKey": null
                    },
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "statusCode",
                                "storageKey": null
                            },
                            (v2 /*: any*/)
                        ],
                        "type": "GraphEntityError",
                        "abstractKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "Event",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '9d6bec4d27a30c52cb92c12f5bf09481';
export default node;
